module.exports = __webpack_public_path__ + "static/media/tiq.3955fed0.jpeg";